import React from 'react'
import { ExpertiseTypes } from '../../types/preferences.types'
import { HomeIcon, EnergyIcon, KeyIcon } from '../Icons'
import './ExpertiseSection.styles.css'

interface ExpertiseSectionProps {
  expertiseTypes: ExpertiseTypes
  onChange: (expertiseTypes: ExpertiseTypes) => void
}

interface ExpertiseCard {
  id: keyof ExpertiseTypes
  label: string
  icon: React.ReactNode
  color: string
}

export const ExpertiseSection: React.FC<ExpertiseSectionProps> = ({ 
  expertiseTypes, 
  onChange 
}) => {
  const expertiseCards: ExpertiseCard[] = [
    {
      id: 'expertisesImmobilieres',
      label: 'Expertises immobilières',
      icon: <HomeIcon size={32} color="#007bff" />,
      color: '#007bff'
    },
    {
      id: 'certificationPEB',
      label: 'Certification PEB',
      icon: <EnergyIcon size={32} color="#ffc107" />,
      color: '#ffc107'
    },
    {
      id: 'permisLocation',
      label: 'Permis de location',
      icon: <KeyIcon size={32} color="#28a745" />,
      color: '#28a745'
    }
  ]

  const handleToggle = (type: keyof ExpertiseTypes) => {
    onChange({
      ...expertiseTypes,
      [type]: !expertiseTypes[type]
    })
  }

  return (
    <div className="expertise-section">
      <div className="section-header">
        <h2 className="section-title">Types d'expertises</h2>
        <p className="section-description">
          Sélectionnez les types d'expertises que vous réalisez
        </p>
      </div>
      
      <div className="expertise-grid">
        {expertiseCards.map(card => (
          <label key={card.id} className="expertise-item">
            <input 
              type="checkbox" 
              checked={expertiseTypes[card.id]}
              onChange={() => handleToggle(card.id)}
            />
            <div className="expert-pref-expertise-card">
              <div className="expertise-check">
                <svg 
                  width="14" 
                  height="14" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="3"
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              <span className="expertise-icon">
                {card.icon}
              </span>
              <span className="expertise-name">{card.label}</span>
            </div>
          </label>
        ))}
      </div>
      
      <div className="expertise-info">
        <p className="info-text">
          ℹ️ Les types d'expertises sélectionnés déterminent les missions qui vous seront proposées
        </p>
      </div>
    </div>
  )
}